"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sizes = require("@decisiv/design-tokens/lib/iconography/sizes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SvgPhoneArrowIn = function SvgPhoneArrowIn(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: _sizes.alias[size],
    height: _sizes.alias[size],
    color: color,
    focusable: "false"
  }, props), _react.default.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, _react.default.createElement("path", {
    d: "M9.997 8.83a1 1 0 01.831.091l3.536 2.121a1 1 0 01.192 1.565l-2.121 2.121a1 1 0 01-1.414-1.414l1.215-1.216-2.043-1.225-1.685.561a1 1 0 01-1.023-.241L4.657 8.364a1 1 0 01-.242-1.023l.562-1.685L3.75 3.613 2.627 4.737c-1.063 1.878-.462 3.964 2.03 6.456 1.324 1.324 2.556 2.12 3.68 2.41a1 1 0 01-.5 1.936c-1.512-.39-3.038-1.375-4.595-2.932-3.12-3.12-3.957-6.19-2.271-9a1 1 0 01.15-.192l2.121-2.122a1 1 0 011.565.193L6.928 5.02a1 1 0 01.092.831l-.512 1.535 1.954 1.955 1.535-.512zM13.414 4H15a1 1 0 010 2h-4a1 1 0 01-1-1V1a1 1 0 012 0v1.586L14.293.293a1 1 0 011.414 1.414L13.414 4z"
  })));
};

SvgPhoneArrowIn.propTypes = {
  size: _propTypes.default.oneOf(Object.keys(_sizes.alias)),
  color: _propTypes.default.string
};
var _default = SvgPhoneArrowIn;
exports.default = _default;